import React from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import InfoTrack from "./components/InfoTrack";
import ControlPlayer from "./components/ControlPlayer";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/redux-hooks";
import {
  selectMainState,
  setButtonState,
  setPlayRadio,
} from "../../../../../store/slices/main";
import VolumeControl from "../fullScreenRadioPlayer/components/VolumeControl";
import ProgressBar from "../../components/ProgressBar";
import Close from "../../../../../assets/icon/Close";

interface Props {
  cover?: string;
  metadata?: string;
  trackName?: string;
  artist?: string;
  player: IcecastMetadataPlayer;
}

const WidgetRadioPlayer: React.FC<Props> = ({
  cover,
  metadata,
  trackName,
  artist,
  player,
}) => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { radio, overTop, volume },
  } = useAppSelector(selectMainState);

  if (player) {
    player.audioElement.volume = volume / 100;
  }

  const handleClose = () => {
    dispatch(setPlayRadio(false));
    if (player && radio) {
      player.stop();
      dispatch(setButtonState("play"));
    }
  };

  return (
    <div
      className={
        overTop
          ? "fixed w-full bottom-0 left-0 z-[40] min-h-[4rem]"
          : " min-h-[4rem] px-2"
      }
    >
      <div className="flex justify-center bg-bg_player w-screen shadow-[0px_1.0px_0px_0px_rgba(0,0,0,0.10)] opacity-[85%]">
        <div className="flex items-center justify-between flex-row-reverse w-full md:max-w-[45rem] md:flex-row">
          <div className="flex items-center pr-7 ">
            <ControlPlayer player={player} />
          </div>
          <div className="hidden md:flex ">
            <ProgressBar widthScreen="250px" widthProgress="0px" />
          </div>
          <div className="hidden md:flex pl-10 min-w-[7.6rem]">
            <VolumeControl
              player={player}
              widthScreen="50%"
              widthProgress="80%"
              heightProgress="6px"
            />
          </div>
          <div
            className="w-[16rem]flex justify-ceneter items-center sm:w-[18rem] pl-5"
            // onClick={() => {
            //   overTop
            //     ? dispatch(setViewRadioPlayer(true))
            //     : dispatch(setViewRadioPlayer(false));
            // }}
          >
            <div className="max-w-[15rem] w-full flex justify-start pl-3">
              <InfoTrack cover={cover} trackName={trackName} artist={artist} />
            </div>
          </div>
        </div>
      </div>
      <button
        className="block absolute top-2 right-1 md:right-2 p-0.5 hover:bg-black hover:bg-opacity-[4%] rounded-full"
        onClick={() => {
          handleClose();
        }}
      >
        <Close width="w-4" height="h-4" />
      </button>
    </div>
  );
};

export default WidgetRadioPlayer;
